import no from './languages/no.json';
import en from './languages/en.json';
import {debounce} from 'throttle-debounce';
import {pick} from 'dot-object';

const strMap = {
  no,
  en,
};

const debug = false;

export const MISSING_TRANSLATION = '[missing translation]';

const missingKeys = new Set();

const printMissing = debounce(60_000, () => {
  console.error(`Missing i18n for (lang: key):\n  ${[...missingKeys].join('\n  ')}`);
});

export const i18n = key => {
  const lang = localStorage.getItem('language') || 'no';

  const target = strMap[lang];

  const strData = pick(key, target);

  if (strData == null) {
    missingKeys.add(`${lang}: ${key}`);
    printMissing();

    return `${MISSING_TRANSLATION}-${key}`;
  }
  if (debug) {
    return `..${strData}`;
  }

  return strData;
};
